<template>
  <div>
    <div class="branches-section">
      <dashboard-table
        v-for="branchData in executiveDashboardSummary"
        :key="branchData.branch"
        class="dashboard-table"
        :title="branchData.branch"
        :summary="branchData.data"
      />
    </div>
  </div>
</template>

<script>
import DashboardTable from '../../../components/DashboardTable';
import {
  AssignmentsListingActions,
  AssignmentsListingGetters
} from '@/app/features/assignments/features/assignments-listing/assignments-listing.keys';

import { AppActions } from '@/app/app.keys';

export default {
  name: 'ExecutiveDashboard',
  components: {
    DashboardTable
  },
  computed: {
    user() {
      return this.$store.state.currentUser;
    },
    userRoles() {
      return this.$store.state.currentUser.roles.map(r => r.role_name);
    },
    placementActivityCountColumns() {
      return ['Date', 'Active', 'Perms', 'Starts', 'Stops'];
    },
    executiveDashboardSummary() {
      return this.$store.getters[AssignmentsListingGetters.ExecutiveDashboardSummary];
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('dashboard.title'));
    this.$store.dispatch(
      AssignmentsListingActions.RetrieveExecutiveDashboardSummary,
      this.userRoles
    );
  }
};
</script>
<style scoped lang="scss">
.branches-section {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;
  padding: 10px 10px;
  .dashboard-table {
    display: inline-block;
    border-collapse: collapse;
    padding: 10px;
    margin: 10px;
  }
}
</style>
